<template>
    <div class="main__wrapper container relative" :class="comparativeView.numberProducts && comparativeView.numberProducts > 1 ? '-mb-10 lg:-mb-1' : ''">
        <div ref="trigger_compare_tray" id="trigger_compare_tray" :class="'open'" class="btn--compare-tray btn--dark-ad tx-12 sm:tx-14 px-5 sm:px-8 py-2 w-fit weight-700 cursor-pointer rounded-6 absolute xl:r-0 t-0 mr-4 shadow-1 -z-1">
            comparar {{ comparativeView.numberProducts ? comparativeView.numberProducts : '0' }} / 3
        </div>
        <div class="header-compare-tray hidden absolute l-0 t-0 px-4 w-full -z-2 -mt-8">
            <div class="flex justify-content-between align-items-center">
                <p class="weight-500 tx-white m-0">
                    Comparativa
                </p>
                <img class="close-compare-tray cursor-pointer" width="12px" src="/assets/images/helpers/icon-times.svg" alt="">
            </div>
        </div>
        <div class="wrapper-tray py-6 lg:pt-9 lg:pb-10 rounded-4 gs:grid bg-white mx-0">
            <div class="lg:col-14 mb-6 lg:mb-0">
                <div class="grid__compared__cars grid">

                    <div :class="comparativeView.product_one ? 'relative' : 'w-full h-full rounded-4 border-1 border-dashed border-grey-2 py-4'" class="item">
                        <template v-if="comparativeView.product_one">
                            <a class="item thumbnail__car thumbnail__car--lying" :href="'/car/' + comparativeView.product_one.id" target="_blank">
                                <div class="pl-2 py-2">
                                    <div class="render__img"
                                        :style="'background-image: url(\'' + getCoverImage(comparativeView.product_one) + '\');'">
                                        <img v-if="!!comparativeView.product_one.user.documents && comparativeView.product_one.user.documents.status == 'validated'" class="turn_verified hidden" src="/assets/images/layout/turn-verificado.svg" alt="">
                                    </div>
                                </div>
                                <div class="datasheet flex-a">
                                    <div class="rating">
                                        <div class="stars__rating">
                                            <div class="stars_outer">
                                                <div class="stars_inner" :style="'width: ' + averageScore(comparativeView.product_one.average_score) + '%;'"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="title" v-html="comparativeView.product_one.brand.title + ' ' + comparativeView.product_one.model.title" />
                                    <div class="added__badges">
                                        <div class="badge badge--year" v-html="comparativeView.product_one.year" />
                                    </div>
                                    <p class="price">
                                        $ {{ formatPrice(comparativeView.product_one.price) }}
                                        <span>MXN</span>
                                    </p>
                                </div>
                            </a>
                            <span @click="removeProduct(comparativeView.product_one.id)" class="tx-12 tx-red-danger cursor-pointer absolute l-0 b-0 -mb-6">
                                &times;&nbsp;<span class="underline">Eliminar</span>
                            </span>
                        </template>
                        <div class="w-full h-full flex justify-content-center align-items-center" v-else>
                            <p class="tx-12 tx-center tx-grey opacity-70 m-0">
                                Si deseas agregar un auto ingresa a su detalle <br> y haz click en "comparar"
                            </p>
                        </div>
                    </div>

                    <div :class="comparativeView.product_two ? 'relative' : 'w-full h-full rounded-4 border-1 border-dashed border-grey-2 py-4'" class="item">
                        <template v-if="comparativeView.product_two">
                            <a class="item thumbnail__car thumbnail__car--lying" :href="'/car/' + comparativeView.product_two.id" target="_blank">
                                <div class="pl-2 py-2">
                                    <div class="render__img" :style="'background-image: url(\'' + getCoverImage(comparativeView.product_two) + '\');'">
                                        <img v-if="!!comparativeView.product_two.user.documents && comparativeView.product_two.user.documents.status == 'validated'" class="turn_verified hidden" src="/assets/images/layout/turn-verificado.svg" alt="">
                                    </div>
                                </div>
                                <div class="datasheet flex-a">
                                    <div class="rating">
                                        <div class="stars__rating">
                                            <div class="stars_outer">
                                                <div class="stars_inner" :style="'width: ' + averageScore(comparativeView.product_two.average_score) + '%;'"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="title" v-html="comparativeView.product_two.brand.title + ' ' + comparativeView.product_two.model.title" />
                                    <div class="added__badges">
                                        <div class="badge badge--year" v-html="comparativeView.product_two.year" />
                                    </div>
                                    <p class="price">
                                        $ {{ formatPrice(comparativeView.product_two.price) }}
                                        <span>MXN</span>
                                    </p>
                                </div>
                            </a>
                            <span @click="removeProduct(comparativeView.product_two.id)" class="tx-12 tx-red-danger cursor-pointer absolute l-0 b-0 -mb-6">
                                &times;&nbsp;<span class="underline">Eliminar</span>
                            </span>
                        </template>
                        <div class="w-full h-full flex justify-content-center align-items-center" v-else>
                            <p class="tx-12 tx-center tx-grey opacity-70 m-0">
                                Si deseas agregar un auto ingresa a su detalle <br> y haz click en "comparar"
                            </p>
                        </div>
                    </div>

                    <div :class="comparativeView.product_three ? 'relative' : 'w-full h-full rounded-4 border-1 border-dashed border-grey-2 py-4'" class="item">
                        <template v-if="comparativeView.product_three">
                            <a class="item thumbnail__car thumbnail__car--lying" :href="'/car/' + comparativeView.product_three.id" target="_blank">
                                <div class="pl-2 py-2">
                                    <div class="render__img" :style="'background-image: url(\'' + getCoverImage(comparativeView.product_three) + '\');'">
                                        <img v-if="!!comparativeView.product_three.user.documents && comparativeView.product_three.user.documents.status == 'validated'" class="turn_verified hidden" src="/assets/images/layout/turn-verificado.svg" alt="">
                                    </div>
                                </div>
                                <div class="datasheet flex-a">
                                    <div class="rating">
                                        <div class="stars__rating">
                                            <div class="stars_outer">
                                                <div class="stars_inner" :style="'width: ' + averageScore(comparativeView.product_three.average_score) + '%;'"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="title" v-html="comparativeView.product_three.brand.title + ' ' + comparativeView.product_three.model.title" />
                                    <div class="added__badges">
                                        <div class="badge badge--year" v-html="comparativeView.product_three.year" />
                                    </div>
                                    <p class="price">
                                        $ {{ formatPrice(comparativeView.product_three.price) }}
                                        <span>MXN</span>
                                    </p>
                                </div>
                            </a>
                            <span @click="removeProduct(comparativeView.product_three.id)" class="tx-12 tx-red-danger cursor-pointer absolute l-0 b-0 -mb-6">
                                &times;&nbsp;<span class="underline">Eliminar</span>
                            </span>
                        </template>
                        <div class="w-full h-full flex justify-content-center align-items-center" v-else>
                            <p class="tx-12 tx-center tx-grey opacity-70 m-0">
                                Si deseas agregar un auto ingresa a su detalle <br> y haz click en "comparar"
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="comparativeView.numberProducts && comparativeView.numberProducts > 1" class="lg:col-2 flex align-items-end">
                <a class="btn btn--green-ad btn--compare flex xl:ml-a lg:mx-0 tx-14 weight-700 lg:w-full" href="/auto-comparador">
                    Comparar
                </a>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {

        data() {
            return {
                user_id: null,
                comparative: {},

                formData: null,
                err: {}
            }
        },

        computed: {
            ...mapState(['user']),
            ...mapState('comparative', ['comparatives']),
            comparativeView: {
                get: function() {
                    return this.comparative;
                }, set: function(value){
                    this.comparative = value;
                }
            },
        },

        watch: {
            user(state) {
                let vm = this;
                if ( state.id !== undefined ) {
                    vm.user_id = state.id;
                }
            },
            comparatives(state) {
                let vm = this;
                if ( state.id !== undefined ) {
                    vm.comparativeView = state;
                }
            }
        },

        methods: {

            formatPrice(value) {
                let val = (value/1).toFixed(2)
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            averageScore(value) {
                return ( value * 2 ) * 10;
            },

            getCoverImage(product) {
                return product.card_cover ?
                    product.card_cover.image :
                    product.gallery_first.image;
            },

            removeProduct(value) {
                let vm = this;

                    vm.resetForms();
                    vm.formData.append('product_id', value);
                    vm.$swal({
                        icon: "info",
                        title: "Confirmar operación",
                        text: "¿Estas seguro de remover el producto de la comparación?",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonText: 'Aceptar'
                    }).then((result) => {
                        if (result) {
                            let {data} = axios.post('/client/comparatives/update/' + vm.comparatives.id, vm.formData)
                            .then(response => {
                                vm.$store.dispatch('comparative/getComparatives');

                            }).catch(error => {
                                vm.showErrors(error);
                            });
                            vm.$swal({
                                icon: 'success',
                                title: 'Producto removido',
                                text: 'Se removió de la comparación el producto',
                            });
                        }
                    });
            },

            resetForms() {
                let vm = this;
                vm.formData = new FormData();
                vm.err = [];
            },

            showErrors(error = null) {
                let vm = this;
                if ( error ) {
                    vm.err = error.response.data;
                }
                vm.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
                });
            },



        }
    }
</script>


